'use strict';

wbApp.filter('wbMembershipAppliesTo', ['$translate', function ($translate) {
    return function (input) {
        var result = '';
        if (input.applyToCourses) {
            result = $translate.instant('TXT_LBL_COURSES')
        }
        if (input.applyToActions) {
            if (result) {
                result += ', ' + $translate.instant('TXT_LBL_ACTIONS');
            } else {
                result = $translate.instant('TXT_LBL_ACTIONS');
            }
        }

        return result;
    }
}]);